
import { i18nText } from '@/locales';

import { FormModel, Select, Col, Row } from "ant-design-vue";

import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import { mixins } from "vue-class-component";
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import { SimpleProxyForm } from "@/UI/components/Helpers/SimpleProxyForm";
import { PaginationMix } from "@/UI/mixins/PaginationMix";
import { ProductsTableMix } from "@/UI/mixins/Store/ProductsTableMix";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
//import createProduct from "@/form/Warehouse/Products/createProduct"
import { ProductsStore } from "@/store/modules/Warehouse/Products";
import { ProductsMix } from "@/UI/mixins/Store/ProductsMix";
import { ProductsCategoriesMix } from "@/UI/mixins/Store/ProductsCategoriesMix";
import { ProductsTaxMix } from "@/UI/mixins/Store/ProductsTaxMix";
import { ProductsTaxSystemMix } from "@/UI/mixins/Store/ProductsTaxSystemMix";
import { ProductsUnitMix } from "@/UI/mixins/Store/ProductsUnitMix";

import { ProductsCategoriesStore } from "@/store/modules/Warehouse/ProductsCategories";
import { ProductsUnitStore } from "@/store/modules/Warehouse/ProductsUnit";
import { ProductsTaxStore } from "@/store/modules/Warehouse/Tax";
import { ProductsTaxSystemStore } from "@/store/modules/Warehouse/TaxSystem";

import { ProductFormData, FormRules } from "@/form/Warehouse/Products/Product";
import { AppStateStore } from "@/store/modules/appState";
import { showNotification } from "@/UI/lib/messages";
import { RouterNameEnum } from "@/router/router.types";
import { getStudioId } from "@/UI/lib/state";

@Component({
    components: {
        PageTitle,
        FormGroup,
        BaseDataForm,
        "a-select": Select,
        "a-select-option": Select.Option,
        "a-col": Col,
        "a-row": Row,
        "a-form-model": FormModel,
        "a-form-model-item": FormModel.Item,
    },
})
export default class CreateProductForm extends mixins(
    SimpleProxyForm,
    PaginationMix,
    ProductsTableMix,
    ProductsMix,
    ProductsCategoriesMix,
    ProductsTaxMix,
    ProductsTaxSystemMix,
    ProductsUnitMix,
) {
    //@Prop() readonly form!: ProductFormData;
    @Prop() readonly mode!: number;
    form = new ProductFormData(parseInt(this.$route.params.Studio), parseInt(this.$route.params.Store));
    // rules = FormRules;
    selling_price: any = 0
    rules_validation: any = { required: true, message: i18nText("Пожалуйста укажите цену продажи"), trigger: 'change' }

    onInputNumber(number: Event) {
        const target = number.target as HTMLInputElement;
        console.log('onInputNi', target);

        if (target && target.value.startsWith('0')) {
            target.value = target.value.substring(1);
        }

        console.log('onInputNo', target.value);
    }

    async fetchSellingPrice() {
        await ProductsStore.fetchAll({
            filter: {
                salon_id: getStudioId(this),
                name: this.form.name,
                category_id: this.form.category_id
            }
        })
        let data_products: any = ProductsStore.products!.data
        for (let i = 0; i < data_products.length; i++) {
            if (data_products[i]['selling_price'] > 0) {
                this.selling_price = Number(data_products[i]['selling_price'])
                this.rules_validation = {
                    required: true,
                    min: parseInt(this.selling_price) - parseInt(this.selling_price) / 10,
                    max: parseInt(this.selling_price) + parseInt(this.selling_price) / 10,
                    message: i18nText("Цены в одном городе не должны различаться более чем на 10%"),
                    trigger: 'change',
                    type: 'number'
                }
                break
            } else {
                alert("VFAS")
                this.rules_validation = { required: true, message: i18nText("Пожалуйста укажите цену продажи"), trigger: 'change' }
            }
        }
    }

    get rules() {
        return { ...FormRules, selling_price: [this.rules_validation, { min: 1, message: i18nText("Поле должно быть больше 0"), trigger: 'change', type: 'number' }] }
    }

    @Watch("$store.state.appState.sendCancel", { deep: true })
    buttonCancel() {
        Vue.router.push({
            name: RouterNameEnum.ListedProducts,
            params: { Studio: getStudioId(this), idCategory: this.$route.params['idCategory'] },
        });
        AppStateStore.setCancel(false)
    }

    // @Watch("$store.state.appState.sendSubmit", { immediate: true })
    async ButtonSubmit(value: boolean): Promise<void> {
        if (typeof (this.$refs.productsForm as any).model.selling_price === 'string') {
            (this.$refs.productsForm as any).model.selling_price = +(this.$refs.productsForm as any).model.selling_price;
        }
        if (typeof (this.$refs.productsForm as any).model.sale_unit_value === 'string') {
            (this.$refs.productsForm as any).model.sale_unit_value = +(this.$refs.productsForm as any).model.sale_unit_value
        }
        (this.$refs.productsForm as FormModel).validate(async (valid) => {
            if (valid) {
                try {
                    await this.fetchSellingPrice()
                    if (this.$props.mode === 0) {
                        ProductsStore.create(this.form).then((response) => {
                            showNotification(i18nText("Создание товара -") + this.form.name, response);
                        });
                    }
                    if (this.$props.mode === 1) {
                        ProductsStore.update(this.form).then((response) => {
                            showNotification(i18nText("Обновление товара -") + this.form.name, response);
                        });
                    }
                } catch (e) {
                    console.log("Error save data -" + e);
                } finally {
                    //AppStateStore.setSubmit(false);
                    Vue.router.push({
                        name: RouterNameEnum.ListedProducts,
                        params: { Studio: getStudioId(this), idCategory: this.$route.params['idCategory'], }
                    });
                }
            } else {
                // AppStateStore.setSubmit(false);
            }
        });
    }

    constructor() {
        super();
    }
    async created(): Promise<void> {
        try {
            console.log("mode CreateProduct -" + this.$props.mode);
            console.log("****  -" + this.$router.currentRoute.params["Studio"]);

            await this.getCategories(Number(this.$router.currentRoute.params["Studio"]));
            await ProductsCategoriesStore.fetchCategories();

            if (this.$props.mode === 0) {
                await ProductsStore.fetchAll({
                    limit: this.AppPageParams.pageSize,
                    filter: { category_id: this.$route.params.fromCategory },
                });
            }
            if (this.$props.mode === 1) {
                await ProductsStore.fetchData({
                    filter: { id: parseInt(this.$route.params.id) },
                });
                if (this.product) {
                    //ЗАГЛУШКА///////////////////
                    this.form = (this.product as any).data[0]
                    /////////////////////////
                }
            }

            if (!ProductsTaxStore.ready) await ProductsTaxStore.fetchAll();
            if (!ProductsTaxSystemStore.ready) await ProductsTaxSystemStore.fetchAll();
            if (!ProductsUnitStore.ready) await ProductsUnitStore.fetchAll();
            if (!ProductsTaxSystemStore.ready) await ProductsTaxSystemStore.fetchAll();
            if (!ProductsTaxStore.ready) await ProductsTaxStore.fetchAll();

            this.formReady = true;
            this.tableLoad = true;
        } catch (e) {
            console.log("Error parse data -" + e);
        } finally {
            ///AppStateStore.setSubmit(false);
        }
    }
}
